module.exports = __webpack_public_path__ + "img/Screenshot_MET.9b545d65.svg";